import "../../pages/new/new.scss"

import React, { useState,useEffect } from 'react';
import { useNavigate , useParams } from 'react-router-dom';
import { Container, TextField, Button, Box } from '@mui/material';
import { Tabs, Tab } from '@mui/material';
import { getStudentById,getStudentCourses} from '../../services/studentService';
import {StudentInfo} from './StudentInfo';
import {UndertakingCourse} from './UndertakingCourse';
import {ThesisMentor} from './ThesisMentor';
import StudentPerformance from './StudentPerformance';
export const AddStudent = () => {
    const { studentId } = useParams(); 
    const [studentCourse, setStudentCourse] = useState({
        id:'',//this is term_course_id
        termName:'',
        courseName: '',
        instructorNames: '',
        attendance:'',
        gradeReceived:''
       
    });
    const [student, setStudent] = useState({
    
    enrollmentNumber: "",
    name: "",
    dob: "",
    gender: "",
    nationality: "",
    contactNumber: "",
    alternateContactNumber: "",
    email: "",
    status: "",
    fatherName: "",
    motherName: "",
    currentAddress: "",
    permanentAddress: "",
    bloodGroup: "",
    ugDegree: "",
    ugDiscipline: "",
    ugUniversity: "",
    ugGraduationYear: "",
    ugProgramDuration: "",
    ugPercentCGPA: "",
    ugSecuredPercentCGPA: "",
    ugPercentCGPAOutOf: "",
    pgDegree: "",
    pgDiscipline: "",
    pgUniversity: "",
    pgGraduationYear: "",
    pgProgramDuration: "",
    pgPercentCGPA: "",
    pgSecuredPercentCGPA: "",
    pgPercentCGPAOutOf: "",
    totalWorkExperience: "",
    totalAIWorkExperience: "",
    batch: "",
    company: "",
    });
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [viewMode, setViewMode] = useState(false);
    const fetchStudent = async (id) => {
        try {
            const response = await getStudentById(id);
         //   console.log(response.data)
            setStudent(response.data); // Set course details from API response
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };

    const fetchStudentCourses = async (id) => {
        try {
            const response = await getStudentCourses(id);
          //  console.log(response.data)
            setStudentCourse(response.data); // Set course details from API response
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setStudent({ ...student, [name]: value });
    };


    const { id } = useParams();
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    useEffect(() => {
        if (studentId) {
            const path = window.location.pathname;
            if(path.includes('edit-student')){
                setEditMode(true);
            }
            else if(path.includes('view-student')){
                setViewMode(true);
            }
            fetchStudent(studentId);
            fetchStudentCourses(studentId);
            // Set mode to edit if courseId is present
        } else {
            setEditMode(false); // Set mode to add if no courseId is present
            setViewMode(false);            
        }
    }, [studentId]);

    const handleStudentChange = (updatedStudent) => {
        setStudent(updatedStudent);
    };

    const handleStudentCourseChange = () => {
        fetchStudentCourses(studentId);
    };
    const goBack = () => {
        // Handle final form submission
        navigate('/students');
    };
    const handleSubmit = () => {
        // Handle final form submission
        console.log('Final student data:', student);
    };
    return (
      <div>
      <h2>Student : {student.name}</h2>
      <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Student Info" />
          <Tab label="Undertaking Courses" />
          <Tab label="Thesis & Mentor" />
          <Tab label="Performance Summary" /> //No of requests
      </Tabs>
      {activeTab === 0 && <StudentInfo studentData={student} onChange={handleStudentChange} viewMode={viewMode}/>}
      {activeTab === 1 && <UndertakingCourse studentId={studentId} studentData={studentCourse} onChange={handleStudentCourseChange} viewMode={viewMode}/>}
      {activeTab === 2 && <ThesisMentor studentId={studentId}   viewMode={viewMode}/>}
      {activeTab === 3 && <StudentPerformance studentId={studentId}   viewMode={viewMode}/>}

      <button onClick={goBack}>Back</button>
      {/* <button  onClick={handleSubmit}>Submit</button>*/}
  </div>
    );
};


